import { render } from "./EditTenant.vue?vue&type=template&id=259c818d&scoped=true"
import script from "./EditTenant.vue?vue&type=script&lang=js"
export * from "./EditTenant.vue?vue&type=script&lang=js"

import "./EditTenant.vue?vue&type=style&index=0&id=259c818d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259c818d"]])

export default __exports__